import { defineStore } from 'pinia';

export const useModalsStore = defineStore('modals', () => {
    const modals = reactive<TModals>({
        CTA: {
            isOpen: false,
        },
        Result: {
            isOpen: false,
            msg: '',
            desc: '',
            status: '',
        },
        ImagePreview: {
            isOpen: false,
            title: '',
            img: '',
        }
    });

    function openModal(modalType: keyof TModals) {
        modals[modalType].isOpen = true;
    };
    function closeModal(modalType: keyof TModals) {
        modals[modalType].isOpen = false;
    };

    function setResultModalInfo(result: Omit<TModals['Result'], 'isOpen'>) {
        modals.Result = {
            isOpen: modals.Result.isOpen,
            ...result
        };
    };

    function showImagePreview(img: string) {
        modals.ImagePreview.img = img;
        openModal('ImagePreview');
    };

    return { 
        modals, 
        openModal, 
        closeModal, 
        setResultModalInfo,
        showImagePreview
    };
});


type ModalModel<T extends Record<string, any>> = { isOpen: boolean } & T;
type TModals = {
    CTA: ModalModel<{}>,
    Result: ModalModel<{
        msg: string,
        desc: string,
        status: 'success' | 'error' | 'info' | 'warning' | '',
    }>,
    ImagePreview: ModalModel<{ 
        title: string,
        img: string 
    }>,
};